export default "/images/vendor/flag-icon-css/flags/4x3/cn.svg?7977e12a9afade492c93c76be2cb47de";